// ============================================================================
// APP.JSX — HOSPEDEIRO DO ROUTER PROVIDER (V81.0)
// ARQUIVO: src/app/App.jsx
// RESPONSABILIDADE: Mero hospedeiro do <RouterProvider />.
//   Todo o conteúdo de rotas e lógica global foi extraído para AppContent.jsx.
// ============================================================================

import { RouterProvider } from 'react-router-dom';
import router from './router';

export default function App() {
  return <RouterProvider router={router} />;
}
